import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import CreateInvoiceForm from "./components/CreateInvoiceForm";
import { useDispatch, useSelector } from "react-redux";
import { createSales, editPharmaSales } from "../salesThunks"; // Thunk
import { selectSalesVoucherNumber } from "../salesSelectors";
import { fetchSalesVoucherNumber } from "../salesThunks";
import { getSelectedCustomer } from "../../Customers/customersSelectors";
import { calculateTotals } from "../../../utils/sale";
import { salesRecordWithDetailsApi } from "../../../apiservice/sales";
import { App } from "antd";
import { resetEntryDate, setResetSales } from "../salesSlice";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { createSalesPharmaPayload } from "../../../utils/salesPharma";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { formatToCompanyTimezone, getYearFromCompanyDate } from "../../../lib/functions";

const InvoicePharma = () => {
  const { search } = useLocation();
  const { message, modal } = App.useApp();
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(getSelectedCustomer);
  const salesVoucherNumber = useSelector(selectSalesVoucherNumber);
  const { error, salesSuccess, entryDate, } = useSelector((state) => state.salesPharma);
  // let prevDues = selectedCustomer?.accounts[0].balance;
  const [prevDues, setPrevDues] = useState(0);
  const [saveAttempted, setSaveAttempted] = useState(false);
  const authInfo = useSelector(selectAuthInfo);
  const { id, quoteId } = useParams(); // <-- detect edit mode
  const convertId = new URLSearchParams(search).get("convert_from_sale_order");

  const tag_field_id = useSelector((state) => state.salesPharma.tag_field_id);

  const insuranceCompanyId = useSelector(
    (state) => state.salesPharma.insuranceCompanyId
  );
  const selectedDoctorId = useSelector(
    (state) => state.salesPharma.selectedDoctorId
  );
  const patientCopayPercent = useSelector(
    (state) => state.salesPharma.patientCopayPercent
  );
  const patientDueAmount = useSelector(
    (state) => state.salesPharma.patientDueAmount
  );
  const insuranceDueAmount = useSelector(
    (state) => state.salesPharma.insuranceDueAmount
  );

  const isTatmeenProduct = useSelector((state) => state.salesPharma.isTatmeenProduct);
  const ssccCode = useSelector((state) => state.salesPharma.ssccCode);

  const isFieldHidden = (fieldKey, pageKey = "sales_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey
    );
  };

  const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  // ============================================
  // 🚀 COMPLETE TATMEEN VALIDATION FUNCTION
  // ============================================
  // const validateTatmeen = (items) => {
  //   // Only validate if Tatmeen is enabled for UAE


  //   if (!isTatmeenUAE) return { valid: true };

  //   const parentSSCC = ssccCode?.trim() || "";
  //   const cleanedItems = items.filter(row => row.product?.item_id && Number(row.quantity) > 0);

  //   // Check if ANY SSCC is provided (parent or child)
  //   const hasParentSSCC = parentSSCC !== "";
  //   const hasChildSSCC = cleanedItems.some(
  //     item => item.child_sscc_code && item.child_sscc_code.trim() !== ""
  //   );

  //   // ============================================
  //   // RULE 1: If parent SSCC is given, Tatmeen must be enabled
  //   // ============================================
  //   if (hasParentSSCC && !isTatmeenProduct) {
  //     return {
  //       valid: false,
  //       message: "Parent SSCC Code is provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes."
  //     };
  //   }

  //   // ============================================
  //   // RULE 2: If child SSCC is given, Tatmeen must be enabled
  //   // ============================================
  //   if (hasChildSSCC && !isTatmeenProduct) {
  //     return {
  //       valid: false,
  //       message: "Child SSCC Codes are provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes."
  //     };
  //   }

  //   // ============================================
  //   // RULE 3: If Tatmeen is enabled, validate ALL requirements
  //   // ============================================
  //   if (isTatmeenProduct) {
  //     // 3a: Parent SSCC is required
  //     if (!hasParentSSCC) {
  //       return {
  //         valid: false,
  //         message: "Tatmeen is enabled but Parent SSCC Code is missing. Please enter the Parent SSCC Code."
  //       };
  //     }

  //     // 3b: Every item must have batch selected
  //     const itemsWithoutBatch = cleanedItems.filter(
  //       item => !item.batch_id
  //     );

  //     if (itemsWithoutBatch.length > 0) {
  //       const itemNames = itemsWithoutBatch
  //         .map(item => item.product?.item_name || item.product?.display_text || 'Unknown Item')
  //         .join(', ');

  //       return {
  //         valid: false,
  //         message: `Tatmeen is enabled but the following items are missing Batch selection:\n\n${itemNames}\n\nEach item must have a batch selected.`
  //       };
  //     }


  //     if ((hasParentSSCC || hasChildSSCC) && !isTatmeenProduct) {
  //       return {
  //         valid: false,
  //         message:
  //           "Parent SSCC Code or Child SSCC Code has been entered. Please enable Tatmeen before using SSCC codes.",
  //       };
  //     }

  //     // --------------------------------------------
  //     // RULE 2:
  //     // If Tatmeen is enabled,
  //     // Parent SSCC is mandatory.
  //     // --------------------------------------------
  //     if (isTatmeenProduct && !hasParentSSCC) {
  //       return {
  //         valid: false,
  //         message:
  //           "Tatmeen is enabled. Please enter the Parent SSCC Code.",
  //       };
  //     }

  //     // --------------------------------------------
  //     // RULE 3:
  //     // If Tatmeen is enabled,
  //     // every item must have a Child SSCC.
  //     // --------------------------------------------
  //     if (isTatmeenProduct) {
  //       const itemsWithoutChildSSCC = cleanedItems.filter(
  //         (item) => !item.child_sscc_code?.trim()
  //       );

  //       if (itemsWithoutChildSSCC.length > 0) {
  //         const itemNames = itemsWithoutChildSSCC
  //           .map((item) => item.product?.item_name || "Unknown Item")
  //           .join(", ");

  //         return {
  //           valid: false,
  //           message: `Tatmeen is enabled. The following items are missing Child SSCC Code:\n\n${itemNames}`,
  //         };
  //       }
  //     }


  //     // 3c: Every item must have Child SSCC
  //     const itemsWithoutChildSSCC = cleanedItems.filter(
  //       item => !item.child_sscc_code || item.child_sscc_code.trim() === ''
  //     );

  //     if (itemsWithoutChildSSCC.length > 0) {
  //       const itemNames = itemsWithoutChildSSCC
  //         .map(item => item.product?.item_name || item.product?.display_text || 'Unknown Item')
  //         .join(', ');

  //       return {
  //         valid: false,
  //         message: `Tatmeen is enabled but the following items are missing Child SSCC Code:\n\n${itemNames}\n\nEach item must have a Child SSCC Code.`
  //       };
  //     }

  //     // 3d: Child SSCC validation with Parent
  //     const childSSCCs = cleanedItems
  //       .map(item => item.child_sscc_code?.trim() || "")
  //       .filter(code => code !== "");

  //     const distinctChildSSCCs = [...new Set(childSSCCs)];

  //     if (distinctChildSSCCs.length === 1) {
  //       // If all child SSCC are same, parent SSCC should also be the same
  //       const childSSCC = distinctChildSSCCs[0];
  //       if (parentSSCC !== childSSCC) {
  //         return {
  //           valid: false,
  //           message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSSCC}".\n\nParent SSCC must match the Child SSCC when all are the same.`
  //         };
  //       }
  //     } else if (distinctChildSSCCs.length > 1) {
  //       // If multiple distinct child SSCC, parent should NOT match any
  //       if (distinctChildSSCCs.includes(parentSSCC)) {
  //         return {
  //           valid: false,
  //           message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSSCC}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`
  //         };
  //       }
  //     }

  //     // ============================================
  //     // RULE 4: Serial validation
  //     // ============================================
  //     return validateSerialsForTatmeen(cleanedItems);
  //   }

  //   return { valid: true };
  // };

  const validateTatmeen = (items) => {
    if (!isTatmeenUAE) return { valid: true };

    const parentSSCC = ssccCode?.trim() || "";
    const cleanedItems = items.filter(row => row.product?.item_id && Number(row.quantity) > 0);

    // 👇 Get only items that have Tatmeen Required checked
    const tatmeenRequiredItems = cleanedItems.filter(item => item.is_tatmeen_required === true);

    // If no items require Tatmeen, validation passes
    if (tatmeenRequiredItems.length === 0) return { valid: true };

    const hasParentSSCC = parentSSCC !== "";

    // ============================================
    // RULE 1: If Tatmeen is enabled, Parent SSCC is required
    // ============================================
    if (isTatmeenProduct && !hasParentSSCC) {
      return {
        valid: false,
        message: "Tatmeen is enabled but Parent SSCC Code is missing. Please enter the Parent SSCC Code."
      };
    }

    // ============================================
    // RULE 2: Every Tatmeen-required item must have a batch
    // ============================================
    const itemsWithoutBatch = tatmeenRequiredItems.filter(
      item => !item.batch_id
    );

    if (itemsWithoutBatch.length > 0) {
      const itemNames = itemsWithoutBatch
        .map(item => item.product?.item_name || 'Unknown Item')
        .join(', ');
      return {
        valid: false,
        message: `Tatmeen required items missing Batch selection:\n\n${itemNames}`
      };
    }

    // ============================================
    // RULE 3: Every Tatmeen-required item must have Child SSCC
    // ============================================
    const itemsWithoutChildSSCC = tatmeenRequiredItems.filter(
      item => !item.child_sscc_code?.trim()
    );

    if (itemsWithoutChildSSCC.length > 0) {
      const itemNames = itemsWithoutChildSSCC
        .map(item => item.product?.item_name || 'Unknown Item')
        .join(', ');
      return {
        valid: false,
        message: `Tatmeen required items missing Child SSCC Code:\n\n${itemNames}`
      };
    }

    // ============================================
    // RULE 4: Child SSCC validation with Parent
    // ============================================
    const childSSCCs = tatmeenRequiredItems
      .map(item => item.child_sscc_code?.trim() || "")
      .filter(code => code !== "");

    const distinctChildSSCCs = [...new Set(childSSCCs)];

    if (distinctChildSSCCs.length === 1) {
      const childSSCC = distinctChildSSCCs[0];
      if (parentSSCC !== childSSCC) {
        return {
          valid: false,
          message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSSCC}".\n\nParent SSCC must match the Child SSCC when all are the same.`
        };
      }
    } else if (distinctChildSSCCs.length > 1) {
      if (distinctChildSSCCs.includes(parentSSCC)) {
        return {
          valid: false,
          message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSSCC}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.`
        };
      }
    }

    // ============================================
    // RULE 5: Serial validation (only for Tatmeen-required items)
    // ============================================
    return validateSerialsForTatmeen(tatmeenRequiredItems);
  };

  // ============================================
  // 🚀 SERIAL VALIDATION FOR TATMEEN
  // ============================================
  const validateSerialsForTatmeen = (tatmeenItems) => {
    const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
      authInfo?.country === "United Arab Emirates";

    if (!isTatmeenUAE || !isTatmeenProduct) return { valid: true };
    if (tatmeenItems.length === 0) return { valid: true };

    // Collect all serials for cross-item validation
    const allSerials = [];
    const serialToItemMap = {};

    for (const row of tatmeenItems) {
      const serialMode = row.serial_mode || "unit";
      const quantity = Number(row.quantity || 0);
      const selectedSerials = row.selectedSerials || [];

      // ============================================
      // UNIT MODE: Selected serials must match quantity
      // ============================================
      if (serialMode === "unit") {
        // Check if serial count matches quantity
        if (selectedSerials.length !== quantity) {
          return {
            valid: false,
            message: `"${row.product?.item_name || 'Item'}" requires ${quantity} serial number${quantity > 1 ? 's' : ''} but ${selectedSerials.length} selected.\n\nPlease select exactly ${quantity} serial number${quantity > 1 ? 's' : ''} for this item.`
          };
        }

        // Check for duplicates within the same item
        const duplicateWithinItem = selectedSerials.filter(
          (s, index) => selectedSerials.indexOf(s) !== index
        );

        if (duplicateWithinItem.length > 0) {
          return {
            valid: false,
            message: `"${row.product?.item_name || 'Item'}" contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}.\n\nPlease remove duplicate serial numbers.`
          };
        }

        // Store serials for cross-item validation
        selectedSerials.forEach(serial => {
          if (serial && serial.trim()) {
            const trimmedSerial = serial.trim();
            allSerials.push(trimmedSerial);
            if (!serialToItemMap[trimmedSerial]) {
              serialToItemMap[trimmedSerial] = [];
            }
            serialToItemMap[trimmedSerial].push(row.product?.item_name || 'Item');
          }
        });
      }
      // ============================================
      // BATCH MODE: Exactly 1 serial required
      // ============================================
      else if (serialMode === "batch") {
        // Check if exactly 1 serial is selected
        if (selectedSerials.length !== 1) {
          return {
            valid: false,
            message: `"${row.product?.item_name || 'Item'}" (Batch Mode) requires exactly 1 serial number but ${selectedSerials.length} selected.\n\nPlease select exactly 1 serial number for this batch item.`
          };
        }

        // Store serial for cross-item validation
        const serial = selectedSerials[0];
        if (serial && serial.trim()) {
          const trimmedSerial = serial.trim();
          allSerials.push(trimmedSerial);
          if (!serialToItemMap[trimmedSerial]) {
            serialToItemMap[trimmedSerial] = [];
          }
          serialToItemMap[trimmedSerial].push(row.product?.item_name || 'Item');
        }
      }
    }

    // ============================================
    // CROSS-ITEM SERIAL VALIDATION
    // Check if any serial appears in more than one item
    // ============================================
    const serialCount = {};
    allSerials.forEach(serial => {
      serialCount[serial] = (serialCount[serial] || 0) + 1;
    });

    const duplicateSerials = Object.keys(serialCount).filter(
      serial => serialCount[serial] > 1
    );

    if (duplicateSerials.length > 0) {
      const duplicateDetails = duplicateSerials.map(serial => {
        const items = serialToItemMap[serial] || [];
        const uniqueItems = [...new Set(items)];
        return `Serial "${serial}" appears in: ${uniqueItems.join(', ')}`;
      }).join('\n');

      return {
        valid: false,
        message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items in this sale.`
      };
    }

    return { valid: true };
  };


  useEffect(() => {
    if (selectedCustomer?.accounts?.[0]?.balance) {
      setPrevDues(selectedCustomer.accounts[0].balance);
    } else {
      setPrevDues(0);
    }
  }, [selectedCustomer]);

  const navigate = useNavigate();

  // Duplicate row validation
  function validateDuplicateSalesLines(items) {
    const seen = new Set();

    for (const row of items) {
      const key = [
        row.product?.item_id,
        row.batch_id || 0,
        row.packing_name || "",
        Number(row.rate || 0).toFixed(2),
        Boolean(row.bonus)
      ].join("|");

      if (seen.has(key)) {
        return {
          valid: false,
          message: `Duplicate item detected: ${row.product?.item_name}`
        };
      }

      seen.add(key);
    }

    return { valid: true };
  }


  /*fucntion to create payload and perform validation ,call save sales api*/
  const handleOnSaveSales = (
    customer,
    itemsList,
    footerValues,
    taxMode,
    employee,
    selectedSalesAcc,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc
  ) => {
    setSaveAttempted(true);

    // 1️⃣ Clean
    const cleanedItems = itemsList.filter(row =>
      row.product?.item_id && Number(row.quantity) > 0
    );

    if (cleanedItems.length === 0) {
      modal.error({
        title: "Invalid Sales Entry",
        content: "Please add at least one item with quantity."
      });
      return;
    }

    const tatmeenValidation = validateTatmeen(cleanedItems);
    if (!tatmeenValidation.valid) {
      modal.error({
        title: "Tatmeen Validation Error",
        content: tatmeenValidation.message.replace(/\n/g, '\n')
      });
      return;
    }

    const { valid, message } = validateDuplicateSalesLines(cleanedItems);
    if (!valid) {
      modal.error({ title: "Duplicate Item", content: message });
      return;
    }

    const { dueAmount, grandTotal } = calculateTotals(taxMode, cleanedItems, footerValues);

    // ✅ Safe number conversions
    const dueAmountNum = Number(Number(dueAmount).toFixed(2));
    const payCart = Array.isArray(footerValues?.payCart) ? footerValues.payCart : [];
    const cartTotal = payCart.reduce((sum, item) => sum + Number(item.tran_amount || 0), 0);
    const hasConversionRate = Number(footerValues?.conversion_rate) > 0;
    const maxAllowedCartTotal = hasConversionRate ? Number(grandTotal) + 0.1 : Number(grandTotal);
    const paidAmount = Number(footerValues?.paid_amount || 0);
    const cartPaidAmount = Number(footerValues?.paidAmount || 0);

    if (selectedCustomer === null) {
      message.warning("Select customer!");
      return;
    } else if (cleanedItems[0].product === null) {
      message.warning("Please add atleast one item!");
      return;
    } else if (cleanedItems[0].quantity === 0 || null) {
      message.warning("Please add quantity!");
      return;
    }


    // ✅ Credit limit check — skip if null (never set)
    const rawCreditLimit = selectedCustomer?.accounts[0]?.credit_limit;
    if (rawCreditLimit !== null && rawCreditLimit !== undefined) {
      const creditLimitDisplay = Number(Number(rawCreditLimit).toFixed(2));
      const prevDuesDisplay = Number(Number(prevDues).toFixed(2));
      const totalDueAmountDisplay = Number((dueAmountNum + prevDuesDisplay).toFixed(2));
      const availableCreditDisplay = Number((creditLimitDisplay - prevDuesDisplay).toFixed(2));

      if (
        creditLimitDisplay < totalDueAmountDisplay &&
        dueAmountNum !== 0 &&
        customer.acc_type_name != 'patient'  // ✅ keep patient exception
      ) {
        modal.warning({
          title: "Credit Limit is Over of Customer!",
          content: (
            <>
              <p>Total Credit Limit: {creditLimitDisplay.toFixed(2)}</p>
              <p>Used / Required Amount: {totalDueAmountDisplay.toFixed(2)}</p>
              <p>
                Available Credit:{" "}
                <strong style={{ color: "red" }}>
                  {availableCreditDisplay.toFixed(2)}
                </strong>
              </p>
            </>
          ),
        });
        return;
      }
    }

    if (paidAmount !== cartPaidAmount) {
      modal.warning({ title: "Paid Amount & Payment Cart Amount Should be Same !", content: "" });
      return;
    } else if (Number(cartTotal.toFixed(2)) > Number(maxAllowedCartTotal.toFixed(2))) {
      modal.warning({
        title: "Payment amount exceeds total!",
        content: `Cart Total (${cartTotal.toFixed(2)}) should not exceed Grand Total (${Number(grandTotal).toFixed(2)})`,
      });
      return;
    } else {
      for (const item of cleanedItems) {
        console.log(item, "item");

        const currentQty = Number(item.itemInfo?.current_qty || 0);
        const looseQty = Number(item.itemInfo?.loose_qty || 0);
        const saleQty = Number(item.quantity || 0);
        console.log(currentQty, looseQty, saleQty, "saleQty1234");

        const minusSale = authInfo.is_minus_stock_sale === "yes";

        // Minus stock with zero inventory
        if (minusSale && currentQty <= 0) {
          continue;
        }

        // Batch selected
        if (item.batch_id) {

          const batch = (item.batches || []).find(
            b => b.id === item.batch_id
          );

          if (!batch) {
            continue;
          }

          const batchQty = Number(batch.quantity || 0);
          console.log(batchQty, "batchQty");

          // Unit Serial Mode
          // if (item.serial_mode == "unit") {

          //   if (saleQty > batchQty) {

          //     Swal.fire(
          //       "Insufficient Batch Quantity",
          //       `${item.product.item_name}\n\nOnly ${batchQty} quantity is available in the selected batch.`,
          //       "warning"
          //     );

          //     return;
          //   }

          // } else if (item.serial_mode === "batch") {

          //   if (saleQty !== batchQty) {

          //     Swal.fire(
          //       "Invalid Batch Quantity",
          //       `${item.product.item_name}\n\nBatch Serial Mode requires selling the complete batch (${batchQty}).`,
          //       "warning"
          //     );

          //     return;
          //   }

          // }

        } else {
          if (saleQty >= looseQty) {
            Swal.fire(
              "Insufficient Loose Quantity",
              `${item.product.item_name}\n\nOnly ${looseQty} loose quantity is available.`,
              "warning"
            );
            return;
          }
        }
      }

      for (const item of cleanedItems) {

        const currentQty = Number(item.itemInfo?.current_qty || 0);
        const minusSale = authInfo.is_minus_stock_sale === "yes";

        if (minusSale && currentQty <= 0) {
          continue;
        }

        if (!item.batch_id) {
          continue;
        }
        if (isTatmeenProduct && item.is_tatmeen_required) {
          if (item.serial_mode === "unit") {

            if (
              Number(item.quantity || 0) !==
              (item.selectedSerials || []).length
            ) {

              Swal.fire(
                "Invalid Serial Selection",
                `${item.product.item_name}\n\nPlease select ${item.quantity} serial numbers.`,
                "warning"
              );

              return;
            }

          }

          if (item.serial_mode === "batch") {

            if (
              (item.selectedSerials || []).length !== 1
            ) {

              Swal.fire(
                "Invalid Batch Selection",
                `${item.product.item_name}\n\nPlease select exactly one batch serial.`,
                "warning"
              );

              return;
            }

          }
        }

      }

      let formatedDate = null;
      if (entryDate) {
        if (typeof entryDate === 'string' && entryDate.includes('/')) {
          const [day, month, year] = entryDate.split('/');
          formatedDate = dayjs(`${year}-${month}-${day}`).toISOString();
        } else {
          formatedDate = dayjs(entryDate).toISOString();
        }
      }

      let isEditMode = false;
      if (id) isEditMode = true;


      if (isTatmeenProduct) {

        const invalidChildSSCC = cleanedItems.filter(item =>
          item.is_tatmeen_required === true &&  
          !item.child_sscc_code?.trim()
        );

        if (invalidChildSSCC.length) {

          Swal.fire(
            "Child SSCC Missing",
            "Please enter Child SSCC Code for every selected product.",
            "warning"
          );

          return;
        }

      }
      console.log("Redux ssccCode:", ssccCode);
      console.log("Type:", typeof ssccCode);
      const payload = createSalesPharmaPayload(
        customer, cleanedItems, footerValues, taxMode, prevDues, employee,
        selectedSalesAcc, selectedDiscountAcc, selectedTaxAcc, selectedTransportAcc,
        tag_field_id, insuranceCompanyId, selectedDoctorId, patientCopayPercent,
        patientDueAmount, insuranceDueAmount, formatedDate, isEditMode,
        isTatmeenProduct, ssccCode
      );
      console.log("Payload before API", payload);
      console.log(typeof payload.masterData.sscc_code);
      let action = createSales;
      if (id) { payload.sale_id = id; action = editPharmaSales; }
      if (convertId) { payload.orderId = convertId; }

      dispatch(action(payload))
        .unwrap()
        .then((res) => {
          Swal.close();
          if (!res.error) {
            dispatch(setResetSales());
            setPrevDues(0);
            Swal.fire({
              title: id ? "Sales Updated! Do you want to view voucher?" : "Sales Created! Do you want to view voucher?",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Yes, view voucher",
              cancelButtonText: "No, back",
            }).then((result) => {
              if (result.isConfirmed) {
                if (res?.sales == "pharma") {
                  navigate(`/sales/quick-sales-pharma-voucher/${res.sale_id || id}`);
                } else {
                  navigate(`/sales/quick-sales-voucher/${res.sale_id || id}`);
                }
              } else {
                dispatch(setResetSales());
                dispatch(resetEntryDate());
                navigate("/sales");
              }
            });
          } else {
            Swal.fire(res.message || "Something went wrong", "", "warning");
            if (id) navigate("/sales");
          }
        })
        .catch(() => {
          Swal.close();
          Swal.fire("Network ERROR", "", "error");
        });
    }
  };

  useEffect(() => {
    if (salesSuccess?.message) {
      modal.success({
        title: salesSuccess?.message,
        content: "",
      });
      dispatch(setResetSales());

      setPrevDues(0);
    }
  }, [salesSuccess]);

  useEffect(() => {
    dispatch(setResetSales());

  }, []);


  useEffect(() => {
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchSalesVoucherNumber(year));
  }, [entryDate]);

  useEffect(() => {
    if (saveAttempted && error) {
      modal.error({
        title: "Failed to Save Sales",
        content: error.message || "Something went wrong.",
      });
      setSaveAttempted(false);
    }
  }, [error]);

  return (
    <>
      <CreateInvoiceForm
        onSaveSales={handleOnSaveSales}
        prevDues={prevDues}
        salesVoucherNumber={salesVoucherNumber}
        salesSuccess={salesSuccess}
        authInfo={authInfo}
        editId={id}
        convertId={convertId}
        quoteId={quoteId}
      />
    </>
  );
};

export default InvoicePharma;
